/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Exercise_Personal_Goal_AchievedInputs */

const en_us2_exercise_personal_goal_achieved = /** @type {(inputs: Exercise_Personal_Goal_AchievedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Goal reached on ${i?.date}`)
};

const pt_br2_exercise_personal_goal_achieved = /** @type {(inputs: Exercise_Personal_Goal_AchievedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meta batida em ${i?.date}`)
};

const es_419_exercise_personal_goal_achieved = /** @type {(inputs: Exercise_Personal_Goal_AchievedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meta alcanzada el ${i?.date}`)
};

const pt_pt2_exercise_personal_goal_achieved = /** @type {(inputs: Exercise_Personal_Goal_AchievedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Objetivo alcançado em ${i?.date}`)
};

const fr_fr2_exercise_personal_goal_achieved = /** @type {(inputs: Exercise_Personal_Goal_AchievedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Objectif atteint le ${i?.date}`)
};

const de_de2_exercise_personal_goal_achieved = /** @type {(inputs: Exercise_Personal_Goal_AchievedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ziel erreicht am ${i?.date}`)
};

const it_it2_exercise_personal_goal_achieved = /** @type {(inputs: Exercise_Personal_Goal_AchievedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obiettivo raggiunto il ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Goal reached on {date}" |
*
* @param {Exercise_Personal_Goal_AchievedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_achieved = /** @type {((inputs: Exercise_Personal_Goal_AchievedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_AchievedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_achieved(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_achieved(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_achieved(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_achieved(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_achieved(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_achieved(inputs)
	return en_us2_exercise_personal_goal_achieved(inputs)
});
export { exercise_personal_goal_achieved as "exercise-personal.goal_achieved" }